import { get } from "./index";

export const getAllImageGallery = (params) => {
  const request = {
    subUrl: `/website/getCategoryViseImageGallery`,
    params,
  };
  return get(request);
};
